var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.996152 9.86521L0.366563 12.0033L0.0271318 13.1586C-0.0413018 13.3886 0.0216571 13.6377 0.19411 13.8075C0.366563 13.9772 0.612924 14.0402 0.842861 13.9745L1.99802 13.635L4.13589 13.0053C4.47532 12.9068 4.78464 12.7343 5.05016 12.5016C5.08848 12.4687 5.12407 12.4331 5.15965 12.3976L13.4867 4.07229C14.0861 3.47274 14.16 2.55014 13.7111 1.86846C13.6482 1.77264 13.5715 1.67956 13.4867 1.5947L12.4081 0.513314C11.7238 -0.171105 10.6152 -0.171105 9.93084 0.513314L1.60384 8.84132C1.31916 9.12604 1.11112 9.4792 0.996152 9.86521ZM2.25533 10.2348C2.30187 10.0815 2.37851 9.93913 2.48527 9.81867C2.50169 9.80224 2.51538 9.78582 2.5318 9.76939L8.78663 3.51654L10.4838 5.2139L4.23169 11.4695C4.10304 11.5982 3.94154 11.694 3.76635 11.746L3.12581 11.9349L1.62574 12.3757L2.06645 10.8754L2.25533 10.2348Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.9979118954337587937c65838e287293.svg";
export { ForwardRef as ReactComponent };